import { render, staticRenderFns } from "./NoteHealth.vue?vue&type=template&id=4ce219a4"
import script from "./NoteHealth.vue?vue&type=script&lang=js"
export * from "./NoteHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports